import React from 'react'

import { withClickTrack } from 'components/Trackers/ClickTracker'
import { TRACKER_IDS } from 'components/Trackers/trackerIDs'
import { TestIDs } from 'test/utils/testIds'

import { enhance } from './enhance'
import { TopGetStartedButton } from './styled-components'
import {
  OverviewContainer,
  OverviewHeader,
  OverviewParagraph,
  OverviewPricing,
} from './styled-components'
import { Props } from './types'

const GetStartedTopButton = withClickTrack<any, any>(TRACKER_IDS.SPEND_INTRO.GET_STARTED_TOP)(
  TopGetStartedButton,
)

const CardOverview: React.SFC<Props> = ({ getStartedOnPress }) => (
  <OverviewContainer>
    <OverviewHeader data-testid={TestIDs.WELCOME.SPEND.HEADER}>
      Banking that helps you grow
    </OverviewHeader>
    <OverviewParagraph data-testid={TestIDs.WELCOME.SPEND.TEXT}>
      Get the only checking account that saves and invests for you
    </OverviewParagraph>
    <OverviewPricing>Just $3 per month</OverviewPricing>
    <GetStartedTopButton
      onPress={getStartedOnPress}
      data-testid={TestIDs.WELCOME.SPEND.GET_STARTED_CTA_TOP}
    >
      Get started
    </GetStartedTopButton>
  </OverviewContainer>
)

export default enhance(CardOverview)
